module.exports = __webpack_public_path__ + "mo/img/swiper_bg01.a99a6daa.png";